import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import Sortable from 'sortablejs';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import baseGrid from './base';
import 'next/stylesheets/components/grid/project-progress-grid.scss';

Component('tr-project-progress-grid', {
  mixins: [baseGrid, eventListenerMixin],

  properties: {
    teamGuid: String,
    rowSortable: {
      type: Boolean,
      default: false,
    },

    slideOpened: {
      type: Boolean,
      default: false,
    },
    currentSelectedRow: {
      type: String,
      default: '',
    },
  },

  connected() {
    this.slidePage = this.querySelector('tr-slide-page');
    if (this.slidePage.opened) this.slideOpened = true;

    if (this.rowSortable) this.initRowSortable();

    this.listenTo(this, {
      'tr-grid-project-progress-row:afterConnected': this.handleRowConnected.bind(this),
      'tr-grid-project-progress-row:click': ({ target }) => this.openRowDetail(target),
    });

    this.listenTo(this.slidePage, {
      'tr-slide-page:opened': this.handleSlidePageOpened.bind(this),
      'tr-slide-page:beforeClose': this.handleSlidePageBeforeClose.bind(this),
    });
  },

  initRowSortable() {
    const sortableElements = [
      this.querySelector('.grid-content'),
      ...this.querySelectorAll('.grid-group .group-content'),
    ];

    this.rowSortableInstances = sortableElements
      .map(sortableEl => Sortable.create(sortableEl, {
        group: 'tr-grid-project-progress-row',
        sort: true,
        draggable: 'tr-grid-project-progress-row',
        handle: '.drag-handle',
        animation: false,
        fallbackOnBody: true,
        invertSwap: true,
        forceFallback: (window.gon && window.gon.sortableFallback) || false,
        onStart: () => this.classList.add('sorting'),
        onEnd: ({
          to, from, item, oldDraggableIndex, newDraggableIndex,
        }) => {
          // eslint-disable-next-line no-param-reassign
          item.style.transform = null;
          this.classList.remove('sorting');

          if (from !== to || oldDraggableIndex !== newDraggableIndex) {
            $.ajax({
              url: `/teams/${this.teamGuid}/portfolio_manifests/${item.portfolioManifestId}/sorts`,
              method: 'post',
              data: {
                prev_id: item.previousElementSibling ? item.previousElementSibling.portfolioManifestId : '',
                next_id: item.nextElementSibling ? item.nextElementSibling.portfolioManifestId : '',
              },
            });
          }
        },
      }));
  },

  handleRowConnected(event) {
    if (this.taoStatus !== 'ready') return;

    const row = event.target;
    row.updateStickyCellWidth(parseFloat(this.stickyColumnStyle.width));
  },

  updateProjectProgressRow(portfolioManifestId, newProjectProgress) {
    const selector = `tr-grid-project-progress-row[portfolio-manifest-id="${portfolioManifestId}"]`;
    const oldProjectProgress = this.querySelector(selector);
    if (oldProjectProgress) $(oldProjectProgress).replaceWith(newProjectProgress);
  },

  handleSlidePageOpened() {
    this.slideOpened = true;
  },

  handleSlidePageBeforeClose(event) {
    const { trigger } = event.detail;
    if (trigger && (
      closest(trigger, '.grid-content', this) || !closest(trigger, 'body > .wrapper')
    )) {
      event.preventDefault();
      return;
    }
    this.slideOpened = false;
  },

  openRowDetail({ detailUrl, portfolioManifestId }) {
    if (!detailUrl) return;
    if (this.currentSelectedRow && portfolioManifestId !== this.currentSelectedRow) {
      const previousSelectedRow = this.querySelector(`tr-grid-project-progress-row[portfolio-manifest-id="${this.currentSelectedRow}"]`);
      previousSelectedRow.selected = false;
    }
    this.currentSelectedRow = portfolioManifestId;
    this.slidePage.requestPage(detailUrl);
  },

  disconnected() {
    this.stopListening();
    this.currentSelectedRow = '';

    if (this.rowSortableInstances) {
      this.rowSortableInstances.map(sortable => sortable.destroy());
    }
  },
});
